import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { InferredProgressDays } from 'components/molecules/inferred-progress-days';
import { getIpDays } from 'components/organisms/projects/project-list/helpers/get-ip-days';
import { useProjectDetail } from 'data/projects/hooks';
import { useIsNativeUser } from 'hooks/use-user-type';

interface Props {
  projectId: number;
}

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  text-align: left;
`;
const Right = styled.div`
  text-align: right;
`;

export const Title: FC<Props> = ({ projectId }) => {
  const isNativeUser = useIsNativeUser();
  const { data: project } = useProjectDetail(ProjectId(projectId));
  const ipDays = project ? getIpDays(project) : null;

  return (
    <TitleContainer>
      <Left>
        <strong>
          <FormattedMessage id="project.overview.planned_vs_actual.title" />
        </strong>
      </Left>
      {isNativeUser && ipDays != null ? (
        <Right>
          <InferredProgressDays count={ipDays} />
        </Right>
      ) : null}
    </TitleContainer>
  );
};
